import Icon from '../components/Icon.vue'

Icon.register({
  'trash-restore-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M32 464v-336h384v336c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48zM123.3 291.2c-10.1 10.6-2.9 28.8 11.3 28.8h57.4v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-112h57.4c14.3 0 21.4-18.2 11.3-28.8l-89.4-94.3c-2.5-2.7-7.6-4.9-11.3-4.9s-8.8 2.2-11.3 4.9zM432 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h120l9.4-18.7c3.6-7.3 13.1-13.3 21.3-13.3h0.1 114.3 0c8.2 0 17.8 6 21.5 13.3l9.4 18.7h120z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trash-restore-alt.js
// module id = 2032
// module chunks = 0